import React, { Component } from 'react';
import { Card, Table, Badge, Divider, Button } from 'antd';
import ForecastLocal from './forecastLocal.jsx'
import ModelExplanation from './ModelExplanation.jsx' // Added import for explanation component

// Import mock util (using relative path within src)
import { apiUtil as Util } from '../../mock/mockServices';

const statusSet = [null, <Badge color="geekblue" text="Submitted" />, <Badge status="processing" text="Running" />, <Badge status="success" text="Success" />, <Badge status="error" text="Failed" />]


class GetList extends Component {
  state = {
    tableLoading: false,
    forecastLocalVisible: false,
    modelExplanationVisible: false, // Added state for explanation modal
    localForecastId: '',
    explanationModel: null, // Added state for explanation model
    explainableModels: [], // 添加可解释模型列表
    pagination: {
      current: 1,
      pageSize: 20,
      showTotal: total => `${total} items `,
      total: 0
    },
    data: []
  }

  // 添加定时器引用
  refreshInterval = null;
  explainablePollTimer = null;
  _explainablePollToken = 0;

  getRecordList() {
    const { pagination } = this.state
    this.setState({
      tableLoading: true
    })
    // Use mock API instead of real one
    Util.ajax.post('/train/getTrainRecord', {
      database: 'auto_ml',
      type: 'final_train',
      pageNum: pagination.current,
      pageSize: pagination.pageSize
    }).then(res => {
      pagination.total = res.data.total
      this.setState({
        data: res.data.list || [],
        pagination,
        tableLoading: false
      })

      // 检查是否有正在运行的任务，如果有则启动自动刷新
      this.checkForRunningTasks(res.data.list || []);
      // 兜底轮询：新训练刚完成时后端可能尚未加载完成，/models 暂不含该模型
      this.ensureExplainableModels(this.getCompletedModelIds(res.data.list || []));
    }).catch(error => {
      // Mock records whose IDs match the backend's /models list so the
      // "Explain" buttons route to the real model-explainer endpoints.
      // The third row demonstrates "Explain disabled" — its id isn't
      // in the backend's model list so isModelExplainable returns false.
      const mockData = [
        {
          id: '302',
          projectName: 'GN3.1 Iris',
          userName: 'Mock User',
          createTime: '2026-06-10 10:00:00',
          status: 3, // Success
          coreData: 'Overall portfolio: 0.9159'
        },
        {
          id: '304',
          projectName: 'GN3.1 Model 304',
          userName: 'Mock User',
          createTime: '2026-07-22 09:30:00',
          status: 3,
          coreData: 'Overall portfolio: 0.8971'
        },
        {
          id: '293',
          projectName: 'GN3.1 Model 293',
          userName: 'Mock User',
          createTime: '2026-05-01 14:20:00',
          status: 3,
          coreData: 'Overall portfolio: 0.9012'
        },
        {
          id: 'legacy_001',
          projectName: 'Legacy Model (not in backend)',
          userName: 'Mock User',
          createTime: '2024-01-01 08:00:00',
          status: 3,
          coreData: 'Explain disabled'
        }
      ];

      this.setState({
        data: mockData,
        pagination: {
          ...pagination,
          total: mockData.length
        },
        tableLoading: false
      });

      // 检查是否有正在运行的任务，如果有则启动自动刷新
      this.checkForRunningTasks(mockData);
      this.ensureExplainableModels(this.getCompletedModelIds(mockData));
    });
  }

  // 检查是否有正在运行的任务
  checkForRunningTasks = (data) => {
    // 检查是否有状态为1（已提交）或状态为2（运行中）的任务
    const hasActiveTasks = data.some(item => item.status === 1 || item.status === 2);

    // 如果有活动任务但没有启动定时器，则启动定时器
    if (hasActiveTasks && !this.refreshInterval) {
      this.startAutoRefresh();
    }
    // 如果没有活动任务但启动了定时器，则清除定时器
    else if (!hasActiveTasks && this.refreshInterval) {
      this.stopAutoRefresh();
    }
  }

  // 启动自动刷新
  startAutoRefresh = () => {
    // 清除可能已存在的定时器
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }

    // 每5秒刷新一次数据
    this.refreshInterval = setInterval(() => {
      this.getRecordList();
    }, 5000);
  }

  // 停止自动刷新
  stopAutoRefresh = () => {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
      this.refreshInterval = null;
    }
  }

  // 获取可解释的模型列表
  getExplainableModels() {
    return Util.ajax.get('/models').then(res => {
      console.log('Received models API response:', res);
      if (res.success && Array.isArray(res.data)) {
        // 提取模型前缀作为可解释模型的标识
        const explainableModels = res.data.map(item => item.prefix);
        console.log('Parsed explainable models:', explainableModels);
        this.setState({
          explainableModels
        });
        return explainableModels;
      }
      return this.state.explainableModels;
    }).catch(error => {
      console.error('Failed to fetch explainable models:', error);
      // 出错时保留上次已知列表，绝不回退到写死前缀，避免新模型永远不可解释
      return this.state.explainableModels;
    });
  }

  // 从训练记录中提取已完成(status=3)的模型ID
  getCompletedModelIds = (data) => {
    return (data || [])
      .filter(item => item.status === 3)
      .map(item => String(item.id));
  }

  // 停止可解释模型轮询
  stopExplainablePolling = () => {
    this._explainablePollToken += 1;
    if (this.explainablePollTimer) {
      clearTimeout(this.explainablePollTimer);
      this.explainablePollTimer = null;
    }
  }

  // 轮询 /models 直到所有已完成的训练记录都可解释，或达到超时上限。
  ensureExplainableModels = (expectedIds) => {
    if (!expectedIds || expectedIds.length === 0) return;
    const missing = expectedIds.filter(id => !this.state.explainableModels.includes(id));
    if (missing.length === 0) return;

    this.stopExplainablePolling();
    const pollToken = (this._explainablePollToken += 1);

    const maxAttempts = 24; // 24 * 5s = 120s 上限
    const intervalMs = 5000;
    let attempts = 0;

    const tick = () => {
      if (this._explainablePollToken !== pollToken) return;
      attempts += 1;
      if (attempts > maxAttempts) {
        this.stopExplainablePolling();
        return;
      }
      this.getExplainableModels().then((models) => {
        if (this._explainablePollToken !== pollToken) return;
        const stillMissing = expectedIds.filter(id => !models.includes(id));
        if (stillMissing.length === 0) {
          this.stopExplainablePolling();
          return;
        }
        this.explainablePollTimer = setTimeout(tick, intervalMs);
      });
    };

    this.explainablePollTimer = setTimeout(tick, intervalMs);
  }

  componentDidMount() {
    this.getRecordList();
    this.getExplainableModels(); // 获取可解释的模型列表

    // Listen for model list refresh event
    window.addEventListener('modelListRefresh', this.handleModelListRefresh);
  }

  // 组件卸载时清理定时器
  componentWillUnmount() {
    this.stopAutoRefresh();
    this.stopExplainablePolling();
    // Remove event listener
    window.removeEventListener('modelListRefresh', this.handleModelListRefresh);
  }

  handleTableChange = pagination => {
    console.log(pagination);

    const pager = { ...this.state.pagination }
    pager.current = pagination.current
    this.setState({
      pagination: pager
    }, () => {
      this.getRecordList();
    })
  };

  forecastLocal = row => {
    this.setState({
      localForecastId: row.id,
      localForecastProjectName: row.projectName,
      forecastLocalVisible: true
    })
  }

  // 检查模型是否支持解释功能
  isModelExplainable = (modelId) => {
    // 确保modelId是字符串类型，以便与explainableModels数组中的字符串匹配
    const modelIdStr = typeof modelId === 'string' ? modelId : String(modelId);
    const isExplainable = this.state.explainableModels.includes(modelIdStr);
    console.log('Checking if model is explainable - modelId:', modelIdStr, 'explainableModels:', this.state.explainableModels, 'result:', isExplainable);
    return isExplainable;
  }

  // Added method to show model explanation
  showModelExplanation = row => {
    // 只有在模型支持解释时才显示解释界面
    // For historical predictions, use modelId. For model list, use id.
    const idToCheck = row.modelId || row.id;
    if (this.isModelExplainable(idToCheck)) {
      let modelData = { ...row };
      // For predictions, projectName may not be on the record; look it up from the training list
      if (!modelData.projectName && modelData.modelId) {
        const trainingRecord = this.state.data.find(d => String(d.id) === String(modelData.modelId));
        if (trainingRecord) {
          modelData.projectName = trainingRecord.projectName;
        }
      }
      this.setState({
        explanationModel: modelData,
        modelExplanationVisible: true
      })
    }
  }

  // Added method to close model explanation
  closeModelExplanation = () => {
    this.setState({
      modelExplanationVisible: false,
      explanationModel: null
    })
  }

  reLoad = () => {
    this.getRecordList()
  }

  // Handle model list refresh event
  handleModelListRefresh = () => {
    // Refresh both model list and explainable models
    this.getRecordList();
    this.getExplainableModels();
    // 训练刚完成时 /models 可能尚未包含新模型，轮询兜底直到可解释
    this.ensureExplainableModels(this.getCompletedModelIds(this.state.data));
  }
  editClose = () => {
    this.setState({
      forecastLocalVisible: false
    })
  }

  render() {
    const columns = [
      {
        title: 'Project ID',
        dataIndex: 'id'
      },
      {
        title: 'Project Name',
        dataIndex: 'projectName'
      },
      {
        title: 'Creator',
        dataIndex: 'userName',
        render: name => name ? decodeURIComponent(name) : ''
      },
      {
        title: 'Creation Time',
        dataIndex: 'createTime',
        render: time => Util.dateFormat(time)
      },
      {
        title: 'Training Results',
        dataIndex: 'status',
        render: (status, row) => {
          return (
            (status === 3 || status === 4) ? <div>
              {status === 4 && <div style={{ marginBottom: 4 }}>{statusSet[status]}</div>}
              {status === 3 && (
                <div>
                  {row.coreData}
                  <Divider type="vertical" />
                  <Button
                    type="primary"
                    size="small"
                    onClick={() => this.showModelExplanation(row)}
                    disabled={!this.isModelExplainable(row.id)} // 根据模型是否支持解释来禁用按钮
                  >
                    Explain
                  </Button>
                </div>
              )}
              <div>
                <Button type="link" size="small" disabled={row.status !== 3} onClick={() => window.open(`/get/train/download/${row.id}`)}> Download Report </Button>
                <Divider type="vertical" />
                <a target="_blank" rel="noreferrer" href={`/get/train/download/log/${row.id}`}>Download Training Log</a>
              </div>
            </div> : statusSet[status]
          )
        }
      },
      {
        title: 'Actions',
        dataIndex: 'active',
        key: 'active',
        align: 'center',
        render: (active, row) => {
          return (
            <div>
              <Button type="primary" size="small" disabled={row.status !== 3} onClick={() => this.forecastLocal(row)}>
                Predict
              </Button>
            </div>
          )
        }
      }
    ];

    return (
      <div className="page-content">
        <Card title="G.E.T Training Records" bordered={false} style={{ width: '100%' }}>
          <Table
            rowKey={record => record.id}
            columns={columns}
            loading={this.state.tableLoading}
            dataSource={this.state.data}
            pagination={this.state.pagination}
            onChange={this.handleTableChange}
          />
        </Card>
        <ForecastLocal
          visible={this.state.forecastLocalVisible}
          id={this.state.localForecastId}
          projectName={this.state.localForecastProjectName}
          onClose={this.editClose}
          onReload={this.reLoad}
          onExplain={this.showModelExplanation}
        ></ForecastLocal>
        {/* Added ModelExplanation component as a Drawer instead of Modal */}
        <ModelExplanation
          visible={this.state.modelExplanationVisible}
          model={this.state.explanationModel}
          onClose={this.closeModelExplanation}
        />
      </div>
    );
  }
}

export default GetList;